import { ChangeDetectorRef, Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subject, Observable, takeUntil, tap, catchError, finalize, of, map } from 'rxjs';
// Models
import { MultipleApiResponse, TrackNetwork, TrackNetworkSegment, User } from '@mocca-technologies/model';
// Services
import { OperationsService } from 'src/app/services/operations.service';
import { TracksService } from 'src/app/services/tracks.service';
import { HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { HttpResponsesService } from 'src/app/services/httpResponses.service';

@Component({
  selector: 'app-check-near-tracks',
  templateUrl: './check-near-tracks.component.html',
  styleUrls: ['./check-near-tracks.component.scss'],
})
export class CheckNearTracksComponent implements OnInit, OnDestroy {

    /**
     * Variables
     */
    user = JSON.parse(localStorage.getItem('user')) as User;
    private _latitude: number;
    private _longitude: number;
    private _radius: number = 5000; // meters, 5 km
    isLoading: boolean = false;

    /**
     * Getters and Setters
     */
    get radius(): number {
      return this._radius;
    }

    set radius(value: number) {
      if (this._radius !== value) {
        this._radius = value;
        this.radiusChange.emit();
        this.loadTrackSegments().subscribe();
        // this.loadTracks().subscribe();
      }
    }

    /**
     * Outputs
     */
    @Output() trackNetworkSearch = new EventEmitter<TrackNetwork[]>();
    @Output() trackNetworkSegmentSearch = new EventEmitter<TrackNetworkSegment[]>();
    @Output() radiusChange = new EventEmitter<void>();
    @Output() refreshCenter = new EventEmitter<void>();

    /**
     * Subject to handle the component destruction
     */
    private destroy$ = new Subject<void>();

    constructor(
      private cdr : ChangeDetectorRef,
      private tracksService: TracksService,
      private httpResponseService: HttpResponsesService,
    ) { }

  //#region --> Lifecycle --------------------------
    ngOnInit() {


    }

    ngOnDestroy(): void {
      console.log('Destroying CheckNearTracksComponent');
      this.destroy$.next();
      this.destroy$.complete();
      console.log('CheckNearTracksComponent destroyed');
    }

  //#endregion --> Lifecycle --------------------------

  //#region --> Data Loading --------------------------

loadTrackSegments(): Observable<TrackNetworkSegment[]> {
  this.isLoading = true;
  const radius = this._radius + (this._radius / 3);

  return this.tracksService
    .getNearTrackNetworkSegments(this._latitude, this._longitude, radius, this.user?.username, this?.user?.hashPassword)
    .pipe(
      takeUntil(this.destroy$),

      // Transform HttpResponse -> TrackNetworkSegment[]
      map((res: HttpResponse<MultipleApiResponse>) => {
        const trackNetworkSegmentSearch =
          (res?.body?.responseObject as TrackNetworkSegment[]) ?? [];

        console.log('track network segments found:', trackNetworkSegmentSearch);
        this.trackNetworkSegmentSearch.emit(trackNetworkSegmentSearch);

        return trackNetworkSegmentSearch; // ⬅️ Observable now emits TrackNetworkSegment[]
      }),

      catchError((error: HttpErrorResponse) => {
        this.httpResponseService.showServerError(error?.status, error?.error);
        this.trackNetworkSegmentSearch.emit([]);
        return of([] as TrackNetworkSegment[]); // keep type consistent
      }),

      finalize(() => {
        this.isLoading = false;
        this.cdr.detectChanges();
      })
    );
}

    /**
     * Load the urban areas around the current position and radius defined
     * Uses RxJS operators to handle the asynchronous flow and error cases
     * @returns Observable<TrackNetwork[]>
     */
loadTracks(): Observable<TrackNetwork[]> {
  this.isLoading = true;
  const radius = this._radius + (this._radius / 3);

  return this.tracksService
    .getNearNetworkTracks(this._latitude, this._longitude, radius, this.user?.username, this?.user?.hashPassword)
    .pipe(
      takeUntil(this.destroy$),

      // Transform the response → TrackNetwork[]
      map((res: HttpResponse<MultipleApiResponse>) => {
        const trackNetworkSearch =
          res?.body?.responseObject as TrackNetwork[] || [];

        console.log('track networks found:', trackNetworkSearch);
        this.trackNetworkSearch.emit(trackNetworkSearch);

        return trackNetworkSearch;   // ⬅️ THIS is what your Observable now emits
      }),

      catchError((error: HttpErrorResponse) => {
        this.httpResponseService.showServerError(
          error?.status,
          error?.error,
        );
        this.trackNetworkSearch.emit([]);
        return of([] as TrackNetwork[]);  // keep type consistent
      }),

      finalize(() => {
        this.isLoading = false;
        this.cdr.detectChanges();
      })
    );
}


  //#endregion --> Data Loading --------------------------

  //#region --> Methods --------------------------

    /**
     * Update the current position and load the near infrastructures
     * @param latitude number
     * @param longitude number
     */
    updatePosition(latitude: number, longitude: number) {
      this._latitude = latitude;
      this._longitude = longitude;
      // this.loadTracks().subscribe();
      this.loadTrackSegments().subscribe();
    }

    /**
     * Emit the event radiusChange to notify the parent component that the radius has changed
     */
    onRadiusChange() {
      this.radiusChange.emit();
    }

  //#endregion --> Methods --------------------------
  }
